/* ===== Timer Tea — JS isolé ===== */
(function(){
  const root = document.getElementById('timer-tea');
  if(!root) return;

  const mm = root.querySelector('#th-mm');
  const ss = root.querySelector('#th-ss');
  const startBtn = document.getElementById('th-start');
  const stopBtn  = document.getElementById('th-stop');
  const resetBtn = document.getElementById('th-reset');
  const pills = root.querySelectorAll('.th-pill-btn');
  const rangeLabel = root.querySelector('#th-range-label');

  const defaultSec = parseInt(root.getAttribute('data-default'),10) || 180;
  let remaining = defaultSec;
  let ticker = null;
  let endAt = null;

  function format(n){ return String(n).padStart(2,'0'); }
  function render(){
    const m = Math.floor(remaining/60);
    const s = remaining % 60;
    mm.textContent = format(m);
    ss.textContent = format(s);
  }
  function tick(){
    const now = Date.now();
    remaining = Math.max(0, Math.ceil((endAt - now)/1000));
    render();
    if(remaining <= 0){
      stop();
      root.classList.add('done');
      setTimeout(()=>root.classList.remove('done'), 1200);
    }
  }
  function start(){
    if(ticker || remaining <= 0) return;
    endAt = Date.now() + remaining*1000;
    ticker = setInterval(tick, 250);
    startBtn.setAttribute('disabled','disabled');
  }
  function stop(){
    if(ticker){
      clearInterval(ticker);
      ticker = null;
    }
    startBtn.removeAttribute('disabled');
  }
  function reset(to = defaultSec){
    stop();
    remaining = to;
    render();
    root.classList.remove('done');
  }
  function select(sec, label){
    pills.forEach(b=>b.classList.remove('active'));
    this && this.classList.add('active');
    if(label && rangeLabel){ rangeLabel.textContent = label; }
    reset(sec);
  }

  // Actions
  startBtn.addEventListener('click', start);
  stopBtn.addEventListener('click', stop);
  resetBtn.addEventListener('click', ()=>reset());

  pills.forEach(btn=>{
    btn.addEventListener('click', function(){
      const min = parseFloat(this.dataset.min)||1;
      const max = parseFloat(this.dataset.max)||1;
      const avg = Math.round(((min + max)/2)*60);
      const label = this.dataset.label || '';
      select.call(this, avg, label);
    });
  });

  // Init : sélection par défaut “Thé Vert”
  const first = pills[0];
  if(first){
    const min = parseFloat(first.dataset.min)||1;
    const max = parseFloat(first.dataset.max)||1;
    const avg = Math.round(((min + max)/2)*60);
    const label = first.dataset.label || '';
    select.call(first, avg, label);
  } else {
    render();
  }
})();
